import { SIGN_UP_STATES } from '@jetslash/market-frontend-shared-core/src/models/user';

export default function authModalTitleFromSignUpState(
  signUpState: string,
  defaultTitle: string = 'Log In or Sign Up for Instant Pricing',
) {
  let title;

  switch (signUpState) {
    case SIGN_UP_STATES.newMarketUser:
      title = defaultTitle;
      break;
    case SIGN_UP_STATES.emailIsUnconfirmed:
      title = 'Confirm your email';
      break;
    case SIGN_UP_STATES.phoneNumberIsMissing:
    case SIGN_UP_STATES.phoneNumberTryAgain:
    case SIGN_UP_STATES.phoneNumberIsUnconfirmed:
      title = 'Verify your mobile phone';
      break;
    case SIGN_UP_STATES.accountFullyConfirmed:
      title = 'Account confirmed';
      break;
    default:
      title = defaultTitle;
      break;
  }

  return title;
}
